// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"cc3b8664","104":"85bfd163","133":"9126573f","418":"506ff0b2","453":"f82db826","695":"7a9127c5","737":"b66ac3c5","857":"db844018"}[chunkId] + ".chunk.js";
};